import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import Adminmenu from '../../admin/adminmenu/AdminMenu';
import './AdminLayout.css';
import  AdminDashboard  from '../../admin/AdminDashboard';
import { AHeader } from '../../AHeader';
import { AdminHospitallist } from '../../admin/AdminHospitallist';
import { AdminViewhospital } from '../../admin/AdminViewhospital';
import { AdminDoctor } from '../../admin/AdminDoctor';
import {AdminViewDoctor} from '../../admin/AdminViewDoctor';
import {AdminPatientlist } from '../../admin/AdminPatientlist';
import {AdminViewPatientlist } from '../../admin/AdminViewPatientlist';
import {AdminCases } from '../../admin/AdminCases';
import {AdminViewCases} from '../../admin/AdminViewCases';
import {Adminsupervisorreports} from '../../admin/Adminsupervisorreports';
import {AdminViewSupervisorreport} from '../../admin/AdminViewSupervisorreport';
import {AdminDoctorreports} from '../../admin/AdminDoctorreports';
import {Adminviewdoctorreports} from '../../admin/Adminviewdoctorreports';
import {Admincasedetails} from '../../admin/Admincasedetails';
import{AdminPatientreports} from '../../admin/AdminPatientreports';
import{AdminViewPatientreport} from '../../admin/AdminViewPatientreport';
import {AdminCountry} from '../../admin/AdminCountry';
import {AdminSickness} from '../../admin/AdminSickness';
import { AdminSpeciality } from '../../admin/AdminSpeciality';
import { AdminLanguage } from '../../admin/AdminLanguage';
import { AdminOfficer } from '../../admin/AdminOfficer';
import { AdminPlan } from '../../admin/AdminPlan';
import { AdminActivities } from '../../admin/AdminActivities';
import { AdminRegions } from '../../admin/AdminRegions';
import { AdminPayments } from '../../admin/AdminPayments';
import { ViewAdminprogram } from '../../admin/ViewAdminprogram';
import { ViewPatientHistory } from '../../admin/ViewPatientHistory';
import { AdminDoctorNotes } from '../../admin/AdminDoctorNotes';



interface AdminLayoutProps {

  children?: ReactNode;
  // Define children as a ReactNode
}
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {


  return (
    <div className="admin-layout-container">
      <AHeader/>
      <div >
        <Adminmenu />
        <div >
          <Routes>
             <Route path="/adashboard" element={<AdminDashboard />} />
             <Route path="/hospitallist" element={<AdminHospitallist />} />
              <Route path="/viewprogramadmin/:id" element={<ViewAdminprogram />} />
              <Route path="/viewpatienthistoryadmin/:id" element={<ViewPatientHistory />} />
              <Route path="/viewhospital/:SupervisorID" element={<AdminViewhospital/>} />
              <Route path="/doctorlist" element={<AdminDoctor/>} />
              <Route path="/viewdoctor/:DoctorID" element={<AdminViewDoctor/>} />
              <Route path="/patientlist" element={<AdminPatientlist/>} />
              <Route path="/viewpatienlist/:PatientID" element={<AdminViewPatientlist/>} />
              <Route path="/caseslist" element={<AdminCases/>} />
              <Route path="/viewcaseslist/:CaseID" element={<AdminViewCases/>} />
              <Route path="/supervisorreport" element={<Adminsupervisorreports/>} />
              <Route path="/viewsupervisorreport/:SupervisorID" element={<AdminViewSupervisorreport/>} />
              <Route path="/doctorreport" element={<AdminDoctorreports/>} />
              <Route path="/viewdoctorreport/:DoctorID" element={<Adminviewdoctorreports/>} />
              <Route path="/admincasedetails/:CaseID" element={<Admincasedetails/>} />
              <Route path="/patientreports" element={<AdminPatientreports/>} />
              <Route path="/viewpatientreports/:PatientID" element={<AdminViewPatientreport/>} />
              <Route path="/admincountry" element={<AdminCountry/>} />
              <Route path="/sicknesslist" element={<AdminSickness/>} />
              <Route path="/speciality" element={<AdminSpeciality/>} />
              <Route path="/language" element={<AdminLanguage />} />
              <Route path="/officers" element={<AdminOfficer />} />
              <Route path="/plans" element={<AdminPlan />} />
              <Route path="/adminactivities" element={<AdminActivities />} />
              <Route path="/regions" element={<AdminRegions />} />
              <Route path="/adminpayments" element={<AdminPayments />} />
              <Route path="/adoctornotes/:id" element={<AdminDoctorNotes />} />








          </Routes>
        </div>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default AdminLayout;
